import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const PanelStatusChanged = createAction('[Tickets: Mass Insertion]: Panel Status Changed');

export const TicketSeverityChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket Severity Changed',
  props<{ ticketSeverity: number }>(),
);

export const TicketLSChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket LS Changed',
  props<{ loyaltySchema: number }>(),
);

export const TicketStatusChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket Status Changed',
  props<{ ticketStatus: number }>(),
);

export const TicketCountryChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket Country Changed',
  props<{ country: number }>(),
);

export const TicketCategoryChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket Category Changed',
  props<{ ticketCategory: number }>(),
);

export const TicketAssigneeChanged = createAction(
  '[Tickets: Mass Insertion]: Ticket Assignee Changed',
  props<{ ticketAssignee: number }>(),
);

export const EnablePointerEvents = createAction('[Tickets: Mass Insertion]: Enable Pointer Events');

export const DisablePointerEvents = createAction('[Tickets: Mass Insertion]: Disable Pointer Events');

export const DropZoneEnabled = createAction('[Tickets: Mass Insertion]: Drop Zone Enabled');

export const DropZoneDisabled = createAction('[Tickets: Mass Insertion]: Drop Zone Disabled');

export const FileToUploadChanged = createAction(
  '[Tickets: Mass Insertion]: File To Upload Changed',
  props<{ file: any }>(),
);

export const NotificationEmailChanged = createAction(
  '[Tickets: Mass Insertion]: Notification Email Changed',
  props<{ notificationEmail: string }>(),
);

export const InsertTickets = createAction('[Tickets: Mass Insertion]: Insert Tickets');

export const InsertTicketsSuccess = createAction(
  '[Tickets: Mass Insertion]: Insert Tickets Success',
  props<{ res: any }>(),
);

export const InsertTicketsFailed = createAction(
  '[Tickets: Mass Insertion]: Insert Tickets Failed',
  props<{ error: HttpErrorResponse }>(),
);
